// Search + duplicate-number helpers for the tank management page (accounting feedback 2026-10-13).
// Drivers ask "whose tank is number X?" — one box searches the tank number, the code year
// (ปีรหัส) and the shop name, across every tab.

// The import appended -DUP<n> to numbers that appeared on more than one spreadsheet row
// (e.g. "2567M01" and "2567M01-DUP2") — they are the same number for the "is it a duplicate" question.
export const baseTankNo = (tankId) => String(tankId || '').trim().replace(/-DUP\d*$/i, '').toUpperCase();

// ปีรหัส: the tank's code_generation when it was filled in; otherwise the 25xx year that prefixes
// most registry numbers (2567M01 -> 2567). `derived` tells the UI which of the two it is showing.
export const codeYear = (tank) => {
    const own = String(tank?.codeGeneration || '').trim();
    if (own) return { text: own, derived: false };
    const m = /^(25\d{2})/.exec(String(tank?.tankId || '').trim());
    return m ? { text: m[1], derived: true } : { text: '', derived: false };
};

// Every whitespace-separated word must appear (case-insensitive, partial) in the tank number,
// the code year or the shop name — so "2567 ก๋วย" or "m01 65" narrow down together.
export const matchesSearch = (tank, query) => {
    const words = String(query || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
    if (words.length === 0) return true;
    const hay = [tank?.tankId, tank?.codeGeneration, codeYear(tank).text, tank?.customerName]
        .map((v) => String(v || '').toLowerCase()).join('\n');
    return words.every((w) => hay.includes(w));
};

// Counts over the WHOLE registry (not the filtered view) so a duplicate is flagged even when its twin is on another tab.
export const duplicateInfo = (tanks) => {
    const base = new Map();
    const exact = new Map();
    (tanks || []).forEach((t) => {
        const b = baseTankNo(t.tankId);
        base.set(b, (base.get(b) || 0) + 1);
        const e = String(t.tankId || '').trim();
        exact.set(e, (exact.get(e) || 0) + 1);
    });
    return {
        // same number (ignoring -DUP<n>) on more than one row
        isDuplicate: (t) => (base.get(baseTankNo(t.tankId)) || 0) > 1,
        // literally identical tank_id on more than one row (the by-number endpoints cannot tell these apart)
        isExactDuplicate: (t) => (exact.get(String(t.tankId || '').trim()) || 0) > 1,
        groupCount: [...base.values()].filter((n) => n > 1).length,
        rowCount: [...base.values()].filter((n) => n > 1).reduce((a, b) => a + b, 0),
    };
};

// Keeps the copies of one number next to each other so accounting can compare them side by side.
export const sortByNumberGroup = (tanks) => [...tanks].sort((a, b) => {
    const ka = baseTankNo(a.tankId);
    const kb = baseTankNo(b.tankId);
    if (ka !== kb) return ka < kb ? -1 : 1;
    return String(a.tankId).localeCompare(String(b.tankId)) || (a.id > b.id ? 1 : -1);
});
